import { REGIONS } from './types';

export enum PROD_SUPPORTED_REGIONS {
  US = REGIONS.US,
  CA = REGIONS.CA
}

export const PROD_DEFAULT_REGION = PROD_SUPPORTED_REGIONS.CA;
